"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _finance = require("@/api/finance");
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _rechargeCode = _interopRequireDefault(require("./rechargeCode.vue"));
var _inOutBound = require("@/api/inOutBound");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    cropUpload: _cropUpload.default,
    rechargeCode: _rechargeCode.default
  },
  props: ['item'],
  data: function data() {
    return {
      dialogVisible: false,
      formData: {
        money: 0,
        payMoney: 0
      },
      rules: {
        evidence_url: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }]
      },
      showModalFlag: false,
      payInfo: {
        amount: '',
        code_url: '',
        log_id: '',
        out_trade_no: ''
      }
    };
  },
  mounted: function mounted() {},
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.formData.money = this.item.rent;
        this.formData.payMoney = parseFloat(this.item.rent).toFixed(2);
      }
    }
  },
  methods: {
    submit: function () {
      var _submit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var title, postParams, _this$item, rent, lease_id, order_id, res, x;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.formData.payMoney < 0)) {
                  _context.next = 3;
                  break;
                }
                this.$message.error('操作金额异常');
                return _context.abrupt("return");
              case 3:
                if (!(parseFloat(this.formData.payMoney) > parseFloat(this.formData.money))) {
                  _context.next = 6;
                  break;
                }
                this.$message.error('操作金额过大');
                return _context.abrupt("return");
              case 6:
                title = '';
                if (this.formData.payMoney == this.formData.money) {
                  title = '确认全额还款是吗';
                } else {
                  title = '还款金额比总金额少,线下还款只能一次性还清,请确认是否优惠';
                }
                _context.prev = 8;
                _context.next = 11;
                return this.$confirm(title, '扫码还款', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                });
              case 11:
                console.log('传来的item', this.item);
                postParams = {
                  order_id: this.item.order_id,
                  lease_id: '',
                  paid_rent: ''
                };
                _this$item = this.item, rent = _this$item.rent, lease_id = _this$item.id, order_id = _this$item.order_id; // qrCodePay({
                //     rent,
                //     lease_id,
                //     order_id,
                // }).then((res) => {
                //     sessionStorage.setItem('amount', this.amount)
                //     sessionStorage.setItem('out_trade_no', out_trade_no)
                //     sessionStorage.setItem('qr_code', qr_code)
                //     sessionStorage.setItem('log_id', log_id)
                //     this.$router.push({ name: 'rechargeCode' })
                // })
                _context.next = 16;
                return (0, _inOutBound.qrCodePay)({
                  rent: rent,
                  lease_id: lease_id,
                  order_id: order_id
                });
              case 16:
                res = _context.sent;
                // const res = false
                // const { out_trade_no, qr_code, log_id } = res

                console.log('成功获取参数', res);
                if (res) {
                  this.payInfo = res;
                }
                x = {
                  out_trade_no: '20240316120346856495',
                  qr_code: 'https://qr.alipay.com/bax06421hoehc1z3adt930f2',
                  log_id: 14
                }; // this.payInfo = x
                this.payInfo.amount = this.formData.payMoney;
                // this.payInfo.qr_code = this.payInfo.qr_code
                // this.payInfo.log_id = this.payInfo.log_id
                // this.payInfo.out_trade_no = this.payInfo.out_trade_no

                console.log(' this.payInfo', this.payInfo);
                // this.showModalFlag = true
                this.dialogVisible = false;
                this.$refs.rechargeCode.dialogVisible = true;
                return _context.abrupt("return");
              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](8);
                // 处理错误
                console.log('error', _context.t0);
              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 27]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    closeModal: function closeModal() {
      this.dialogVisible = false;
    },
    refresh: function refresh() {
      var _this = this;
      (0, _finance.setOfflinePay)({
        order_id: this.item.order_id,
        lease_id: this.item.id,
        paid_rent: this.formData.payMoney
      }).then(function (res) {
        _this.dialogVisible = false;
        _this.$emit('success', true);
      });
    }
  }
};
exports.default = _default;